import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Field } from '@tmap/mmm-style-guide/src/final-form/react';
import miniHandlebars from '@tmap/mmm-core/miniHandlebars';
import getFieldConfigByPath from '../../lib/commonApp/getFieldConfigByPath';
import configToProps from './configToProps';
import Question from './question';

function HouseholdFormBody(props) {
  const {
    stage,
    incentive,
    fieldConfigs = [],
  } = props;
  const numAdults = getFieldConfigByPath(fieldConfigs, 'user_profile.household.adults');
  const numChildren = getFieldConfigByPath(fieldConfigs, 'user_profile.household.children');
  const fields = fieldConfigs.filter((fc) => (
    fc.category === stage
    && ![
      'user_profile.household.adults',
      'user_profile.household.children',
    ].includes(fc.path)
  ));
  return (
    <Grid container spacing={{ xs: 4, md: 2 }} alignItems='start'>
      <Grid item xs={12} md={5}>
        <Typography variant='body2' marginTop='16px'>
          {miniHandlebars(numAdults.label, { config: numAdults, incentive })}
        </Typography>
      </Grid>
      <Grid item xs={12} md={7}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Field
              {...configToProps(
                { ...numAdults, label: numAdults.name },
                { config: numAdults, incentive },
              )}
              variant='outlined'
            >
              {numAdults.options && (
                [{ label: '', value: '' }, ...numAdults.options].map((op) => (
                  <option value={op.value} key={op.value}>{op.label}</option>
                )))}
            </Field>
          </Grid>
          <Grid item xs={6}>
            <Field
              {...configToProps(
                { ...numChildren, label: numChildren.name },
                { config: numChildren, incentive },
              )}
              variant='outlined'
            >
              {numChildren.options && (
                [{ label: '', value: '' }, ...numChildren.options].map((op) => (
                  <option value={op.value} key={op.value}>{op.label}</option>
                ))
              )}
            </Field>
          </Grid>
        </Grid>
      </Grid>
      {fields.map((f) => (<Question field={f} data={{ incentive }} key={f.path} titleSpacing='medium' />))}
    </Grid>
  );
}

export default HouseholdFormBody;
